// @ts-nocheck

import Konva from 'konva';
import React from 'react';
import { Text } from 'react-konva';

const getFontPropertiesToFitArea = (text, bounds) => {
  const currentFontSize = bounds.fontSize || 20;
  const currentLetterSpacing = bounds.letterSpacing || 0;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { width, height, ...boundsWithoutWidthAndHeight } = bounds;
  const konvaText = new Konva.Text({ ...boundsWithoutWidthAndHeight, text });
  const currentWidth = Math.ceil(konvaText.getWidth());
  const currentHeight = Math.ceil(konvaText.getHeight());
  let finalFontSize = currentFontSize;
  if (currentWidth > bounds.width || currentHeight > bounds.height) {
    const wFontSize = Math.floor((bounds.width / currentWidth) * currentFontSize);
    const hFontSize = Math.floor((bounds.height / currentHeight) * currentFontSize);
    finalFontSize = Math.min(wFontSize, hFontSize);
  }
  return {
    fontSize: finalFontSize,
    letterSpacing: (finalFontSize / currentFontSize) * currentLetterSpacing,
  };
};

const ScalableText = (props) => {
  const { text, ...bounds } = props;
  const newBounds = {
    ...bounds,
    ...getFontPropertiesToFitArea(text, bounds),
  };
  return (
    <Text
      text={text}
      fontSize={newBounds.fontSize}
      lineHeight={newBounds.lineHeight}
      fontFamily={newBounds.fontFamily}
      x={newBounds.x}
      y={newBounds.y}
      width={newBounds.width}
      height={newBounds.height}
      align={newBounds.align}
      fill={newBounds.fill}
      letterSpacing={newBounds.letterSpacing}
      verticalAlign={bounds.verticalAlign}
      shadowColor={bounds.shadowColor}
      shadowOffsetX={bounds.shadowOffsetX}
      shadowOffsetY={bounds.shadowOffsetY}
      wrap="none"
    />
  );
};

export default ScalableText;
